export const ALL_TIME_LABEL = 'All Time';